import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ColorNames, Icons } from '../navbar/models/notification';

@Component({
  selector: 'app-notification',
  imports: [CommonModule, RouterModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
})
export class NotificationComponent {
  notification = 3;

  title = input<string>('Notificações');
  titleNotification = input<string>('Novas notificações');

  notificationObject: Icons[] = [
    {
      icon: {
        name: 'fas fa-truck',
        color: ColorNames.Primary,
      },
      route: '',
      text: 'Remessas Totais',
      subtitle: '1063144',
    },
    {
      icon: {
        name: 'fas fa-shipping-fast',
        color: ColorNames.Success,
      },
      route: '',
      text: 'Remessas desembaraçadas',
      subtitle: '1063144',
    },
    {
      icon: {
        name: 'fas fa-external-link-alt',
        color: ColorNames.Warning,
      },
      route: '',
      text: 'Master Externos',
      subtitle: '1148',
    },
  ];
}
